import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getActiveBrandConfig } from "../config/environment.config";

/**
 * Exclut de Google l'espace connecté et les pages techniques de l'app,
 * et l'ensemble du site sur les domaines de test.
 * Le serveur (S3/CloudFront) répond 200 pour toutes les routes : sans ce noindex,
 * ces pages peuvent être indexées. Les landings publicitaires ont leur propre noindex
 * (AdsPageLayout), la page 404 aussi (Erreur404).
 */
// Domaines de test (staging-teachr.fr, localhost…) : tout le site est exclu de Google.
// Détection par nom de domaine plutôt que par REACT_APP_BUILD_ENV, dont la valeur
// diffère selon les fichiers .env : la production ne peut pas être exclue par erreur.
const NON_PROD_HOST = /(staging|preview|recette|localhost|127\.0\.0\.1|(^|[.-])dev([.-]|$))/i;

const RobotsMeta = () => {
  const { pathname } = useLocation();
  const isNonProdHost = typeof window !== "undefined" && NON_PROD_HOST.test(window.location.hostname);
  const brand = `/${getActiveBrandConfig()}`;
  const privatePrefixes = [
    `${brand}/tableau-de-bord`,
    `${brand}/profile`,
    `${brand}/cours`,
    `${brand}/candidatures`,
    `${brand}/procuration`,
    "/user/",
    "/client/",
    "/auth/",
    "/maintenance",
    "/comingSoon",
  ];
  const isPrivate = privatePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix.endsWith("/") ? prefix : `${prefix}/`));

  if (!isPrivate && !isNonProdHost) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};

export default RobotsMeta;
